'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var isInteger = Number.isInteger || function (v) {
  return typeof v === 'number' && isFinite(v) && Math.floor(v) === v;
};

function mostSignificantBit(value) {
  var result = value;

  result |= result >> 1;
  result |= result >> 2;
  result |= result >> 4;
  result |= result >> 8;
  result |= result >> 16;
  result |= result >> 32;
  result -= result >> 1;

  return result;
}

/**
 * Class BinaryIndexedTree
 */

var BinaryIndexedTree = (function () {

  /**
   * @param {Object} options
   * @param {number} options.maxVal - The maximum value which will have non-zero frequency
   * @param {number} [options.defaultFrequency=0] - The default initial frequency
   */

  function BinaryIndexedTree() {
    var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var _ref$defaultFrequency = _ref.defaultFrequency;
    var defaultFrequency = _ref$defaultFrequency === undefined ? 0 : _ref$defaultFrequency;
    var maxVal = _ref.maxVal;

    _classCallCheck(this, BinaryIndexedTree);

    this._defaultFrequency = defaultFrequency;
    this._maxVal = maxVal;
    this._tree = { 0: 0 };
    this._msb = mostSignificantBit(maxVal);
    this._countNeg = defaultFrequency < 0 ? maxVal : 0;
  }

  /**
   * The default initial frequency
   * @type {number}
   */

  _createClass(BinaryIndexedTree, [{
    key: '_getTree',
    value: function _getTree(index) {
      if (index in this._tree) {
        return this._tree[index];
      }

      return this._defaultFrequency * (index & -index);
    }
  }, {
    key: '_addTree',
    value: function _addTree(index, delta) {
      this._tree[index] = this._getTree(index) + delta;
    }
  }, {
    key: '_checkIndex',
    value: function _checkIndex(index) {
      if (!isInteger(index)) {
        throw new Error('Invalid index');
      }
      if (index < 0 || index >= this._maxVal) {
        throw new Error('Index out of range');
      }
    }
  }, {
    key: '_checkCount',
    value: function _checkCount(count) {
      if (!isInteger(count)) {
        throw new Error('Invalid count');
      }
      if (count < 0 || count > this._maxVal) {
        throw new Error('Count out of range');
      }
    }
  }, {
    key: '_readSingle',
    value: function _readSingle(idx) {
      var index = idx + 1;
      var sum = this._getTree(index);
      var z = index - (index & -index);

      index--;

      while (index !== z) {
        sum -= this._getTree(index);
        index -= index & -index;
      }

      return sum;
    }
  }, {
    key: '_changed',
    value: function _changed(freqCur, freqNew) {
      if (freqCur < 0 && freqNew >= 0) {
        this._countNeg--;
      } else if (freqCur >= 0 && freqNew < 0) {
        this._countNeg++;
      }
    }
  }, {
    key: '_update',
    value: function _update(idx, delta) {
      var index = idx + 1;

      while (index <= this._maxVal) {
        this._addTree(index, delta);
        index += index & -index;
      }
    }
  }, {
    key: '_writeSingle',
    value: function _writeSingle(idx, freq) {
      var freqCur = this._readSingle(idx);

      this._update(idx, freq - freqCur);
      this._changed(freqCur, freq);
    }
  }, {
    key: '_read',
    value: function _read(count) {
      var index = count;
      var sum = 0;
      while (index) {
        sum += this._getTree(index);
        index -= index & -index;
      }

      return sum;
    }
  }, {
    key: '_find',
    value: function _find(sum, before) {
      var left = 0;
      var right = this._msb << 1;
      var sumT = sum;

      while (right > left + 1) {
        var middle = left + right >> 1;
        var sumM = this._getTree(middle);

        if (middle <= this._maxVal && before(sumM, sumT)) {
          sumT -= sumM;
          left = middle;
        } else {
          right = middle;
        }
      }
      return left;
    }

    /**
     * Read a single frequency
     * @param {number} idx - The 0 based index for the frequency
     * @return {number}
     */
  }, {
    key: 'readSingle',
    value: function readSingle(idx) {
      this._checkIndex(idx);
      return this._readSingle(idx);
    }

    /**
     * Update a single frequency with a delta value
     * @param {number} idx - The 0 based index for the frequency
     * @param {number} delta - The delta value of the freqency
     * @return {undefined}
     */
  }, {
    key: 'update',
    value: function update(idx, delta) {
      this._checkIndex(idx);
      var freqCur = this._readSingle(idx);

      this._update(idx, delta);
      this._changed(freqCur, freqCur + delta);
    }

    /**
     * Update a single frequency with a given value
     * @param {number} idx - The 0 based index for the frequency
     * @param {number} freq - The new frequency
     * @return {undefined}
     */
  }, {
    key: 'writeSingle',
    value: function writeSingle(idx, freq) {
      this._checkIndex(idx);
      this._writeSingle(idx, freq);
    }

    /**
     * Read the sum of the first `count` frequencies
     * @param {number} count - The count of frequencies to accumulate
     * @return {number}
     */
  }, {
    key: 'read',
    value: function read(count) {
      this._checkCount(count);
      return this._read(count);
    }

    /**
     * Read the lower-bound with the given cumulated frequency
     * *REQUIRE ALL FREQUENCIES TO BE NON-NEGATIVE*
     * @param {number} sum - The cumulated frequency
     * @return {number}
     */
  }, {
    key: 'lowerBound',
    value: function lowerBound(sum) {
      if (this._countNeg > 0) {
        throw new Error('Sequence is not non-descending');
      }
      return this._find(sum, function (x, y) {
        return x < y;
      });
    }

    /**
     * Read the upper-bound with the given cumulated frequency
     * *REQUIRE ALL FREQUENCIES TO BE NON-NEGATIVE*
     * @param {number} sum - The cumulated frequency
     * @return {number}
     */
  }, {
    key: 'upperBound',
    value: function upperBound(sum) {
      if (this._countNeg > 0) {
        throw new Error('Sequence is not non-descending');
      }
      return this._find(sum, function (x, y) {
        return x <= y;
      });
    }
  }, {
    key: 'defaultFrequency',
    get: function get() {
      return this._defaultFrequency;
    }

    /**
     * The maximum value which will have non-zero frequency
     * @type {number}
     */
  }, {
    key: 'maxVal',
    get: function get() {
      return this._maxVal;
    }
  }]);

  return BinaryIndexedTree;
})();

exports['default'] = BinaryIndexedTree;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/fast-binary-indexed-tree/dist/index.js
// module id = 14
// module chunks = 0